import { render, staticRenderFns } from "./HomeCTA.vue?vue&type=template&id=3924e036&scoped=true&"
import script from "./HomeCTA.vue?vue&type=script&lang=js&"
export * from "./HomeCTA.vue?vue&type=script&lang=js&"
import style0 from "./HomeCTA.vue?vue&type=style&index=0&id=3924e036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3924e036",
  null
  
)

export default component.exports